// extracted by mini-css-extract-plugin
export default {"group":"sentiment-icon_group__z2lmi","iconWrapper":"sentiment-icon_iconWrapper__qA2o7"};